import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  const isFor = ["El que está cansado de ser el 'prometedor' y quiere ser el que cumple.", 'Quien siente que el tiempo en USA se le escapa sin ver un crecimiento real.', 'Hombres y mujeres que saben que tienen potencial pero están bloqueados por el miedo al error.', 'Quienes necesitan disciplina operativa en su físico y en sus bolsillos.'];
  const notFor = ['Personas que buscan una fórmula mágica sin mover un dedo.', 'Quienes prefieren seguir quejándose de su situación en lugar de actuar.', 'Aquellos que no están dispuestos a seguir instrucciones sencillas por 21 días.'];
  return <section className="py-24 bg-tactical-dark border-b border-tactical-border" data-id="element-58">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-59">
        <FadeIn data-id="element-60">
          <div className="text-center mb-16" data-id="element-61">
            <h2 className="text-4xl font-bold uppercase mb-4" data-id="element-62">
              Parámetros de{' '}
              <span className="text-tactical-accent" data-id="element-63">Selección</span>
            </h2>
            <p className="text-zinc-400 font-mono uppercase text-sm tracking-widest" data-id="element-64">
              Verifica tu compatibilidad con el protocolo
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-65">
          {/* IS FOR */}
          <FadeIn delay={0.1} data-id="element-66">
            <div className="bg-tactical-panel border-t-4 border-t-green-500 p-8 h-full" data-id="element-67">
              <h3 className="font-oswald text-2xl uppercase mb-6 text-zinc-100 flex items-center gap-3" data-id="element-68">
                <span className="bg-green-500/20 p-2 rounded-sm" data-id="element-69">
                  <Check className="w-6 h-6 text-green-500" data-id="element-70" />
                </span>
                Autorizado Para:
              </h3>
              <ul className="space-y-4" data-id="element-71">
                {isFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-zinc-300" data-id="element-72">
                    <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-73" />
                    <span data-id="element-74">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NOT FOR */}
          <FadeIn delay={0.2} data-id="element-75">
            <div className="bg-tactical-panel border-t-4 border-t-red-500 p-8 h-full" data-id="element-76">
              <h3 className="font-oswald text-2xl uppercase mb-6 text-zinc-100 flex items-center gap-3" data-id="element-77">
                <span className="bg-red-500/20 p-2 rounded-sm" data-id="element-78">
                  <X className="w-6 h-6 text-red-500" data-id="element-79" />
                </span>
                Denegado Para:
              </h3>
              <ul className="space-y-4" data-id="element-80">
                {notFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-zinc-400" data-id="element-81">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-82" />
                    <span data-id="element-83">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}